import src from "IMAGE";
export default { src, width: 1432, height: 501, blurWidth: 0, blurHeight: 0};
